/*
 * Public API Surface of ngp-sort
 */

export * from "./lib/sort-by.pipe";
export * from "./lib/ngp-sort.module";
